import * as TActions from './actions.types';
import * as C from './constants';

export const setTheme = (actionData: TActions.ISetThemeParam): TActions.ISetThemeAction => ({
  type: C.SET_THEME,
  payload: {
    theme: actionData.theme,
  },
});
